var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgBlockView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5L0 5.5C0 5.89782 0.158035 6.27936 0.43934 6.56066C0.720644 6.84196 1.10218 7 1.5 7H5.5C5.89782 7 6.27936 6.84196 6.56066 6.56066C6.84196 6.27936 7 5.89782 7 5.5V1.5C7 1.10218 6.84196 0.720644 6.56066 0.43934C6.27936 0.158035 5.89782 0 5.5 0L1.5 0ZM9.5 0C9.10218 0 8.72064 0.158035 8.43934 0.43934C8.15804 0.720644 8 1.10218 8 1.5V5.5C8 5.89782 8.15804 6.27936 8.43934 6.56066C8.72064 6.84196 9.10218 7 9.5 7H13.5C13.8978 7 14.2794 6.84196 14.5607 6.56066C14.842 6.27936 15 5.89782 15 5.5V1.5C15 1.10218 14.842 0.720644 14.5607 0.43934C14.2794 0.158035 13.8978 0 13.5 0L9.5 0ZM1.5 8C1.10218 8 0.720644 8.15804 0.43934 8.43934C0.158035 8.72064 0 9.10218 0 9.5L0 13.5C0 13.8978 0.158035 14.2794 0.43934 14.5607C0.720644 14.842 1.10218 15 1.5 15H5.5C5.89782 15 6.27936 14.842 6.56066 14.5607C6.84196 14.2794 7 13.8978 7 13.5V9.5C7 9.10218 6.84196 8.72064 6.56066 8.43934C6.27936 8.15804 5.89782 8 5.5 8H1.5ZM9.5 8C9.10218 8 8.72064 8.15804 8.43934 8.43934C8.15804 8.72064 8 9.10218 8 9.5V13.5C8 13.8978 8.15804 14.2794 8.43934 14.5607C8.72064 14.842 9.10218 15 9.5 15H13.5C13.8978 15 14.2794 14.842 14.5607 14.5607C14.842 14.2794 15 13.8978 15 13.5V9.5C15 9.10218 14.842 8.72064 14.5607 8.43934C14.2794 8.15804 13.8978 8 13.5 8H9.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockView);
export default __webpack_public_path__ + "static/media/blockView.ad1a955174744c6cfd38cb5a40b94ecc.svg";
export { ForwardRef as ReactComponent };